import {
  FallbackHeaderContainer,
  FallbackHeaderImg,
  FallbackHeaderH1,
  FallbackHeaderH2,
  FallbackHeaderH3,
} from './styles';
const FallbackHeader = () => {
  return (
    <FallbackHeaderContainer>
      <FallbackHeaderImg src="/images/rise-master-logo-linear-rgb.png" alt="Rise Logo" />
      <FallbackHeaderH1>PARDON THE INTERRUPTION</FallbackHeaderH1>
      <FallbackHeaderH2>We are currently down for website maintenance.</FallbackHeaderH2>
      <FallbackHeaderH3>Please scroll or select your state below to shop your local dispensary menu.</FallbackHeaderH3>
    </FallbackHeaderContainer>
  );
};

export default FallbackHeader;
